module.exports = __webpack_public_path__ + "img/user_card_bg.5f0d1e4f.png";